<template>
    <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize"
        :layout.sync="current_page_layout" :page-sizes="pageSizes" :pager-count="pagerCount" :total="total"
        v-bind="$attrs" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
</template>
<script>
//import { themeMixin } from "@/mixins/theme";
//import { scrollTo } from '@/script/scroll-to';
export default {
    name: 'pagination',
    //mixins: [themeMixin],
    props: {
        total: {
            required: true,
            type: Number
        },
        page: {
            type: Number,
            default: 1
        },
        limit: {
            type: Number,
            default: 20
        },
        pageSizes: {
            type: Array,
            default() {
                return [10, 20, 40, 100]
            }
        },
        // 移动端页码按钮的数量端默认值5
        pagerCount: {
            type: Number,
            default: document.body.clientWidth < 992 ? 5 : 5//初始7,相當於100條數據時折疊頁碼
        },
        background: {
            type: Boolean,
            default: true
        },
        autoScroll: {
            type: Boolean,
            default: true
        },
        //自定义配置分页设定
        page_layout: {
            type: String,
            default: ''
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.page
            },
            set(val) {
                this.$emit('update:page', val)
            }
        },
        pageSize: {
            get() {
                return this.limit
            },
            set(val) {
                this.$emit('update:limit', val)
            }
        },
        // 有自定义配置读自定义配置,否则按系统默认配置读取
        current_page_layout() {
            return this.page_layout !== '' ? this.page_layout : this.$store.getters.current_layout;
        }
    },
    methods: {
        //选择页码回调函数
        handleSizeChange(val) {
            // 如果选择的每页条数>总数据默认跳转第一页
            if (this.currentPage * val >= this.total) {
                this.currentPage = 1
            }
            this.$emit('change', { page: this.currentPage, limit: val })
            if (this.autoScroll) {
                //scrollTo(0)
            }
        },
        //选择下拉页回调函数
        handleCurrentChange(val) {
            this.$emit('change', { page: val, limit: this.pageSize })
            if (this.autoScroll) {
                //scrollTo(0)
            }
        }
    },
}
</script>
<style lang="less" scoped>
/* 跳轉樣式調整 */
/deep/.el-pagination__jump {
    margin-left: 0px;
}

/* 分页样式溢出自动换行处理 */
.el-pagination {
    display: contents;
}

/deep/.el-pagination__total {
    margin-right: 0px;
}

/deep/.el-pagination__sizes {
    margin: 0px
}

.el-pagination.is-background /deep/.btn-next,
.el-pagination.is-background /deep/.btn-prev,
.el-pagination.is-background /deep/.el-pager li {
    margin: 0px 2px;
}

.el-pagination /deep/button,
.el-pagination /deep/span:not([class*=suffix]) {
    line-height: 25px;
}
</style>